const isBodyEmpty = (htmlString: string): boolean | undefined => {
    if (typeof window !== "undefined" && typeof window.DOMParser !== "undefined") {
        const parser = new window.DOMParser();
        const doc = parser.parseFromString(htmlString, "text/html");
        const bodyContent = doc.body.innerHTML;
        return !bodyContent.trim();
    }
    return undefined;
};
export default isBodyEmpty;
